// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

// | Vendors ----------------------------------------------------------------

// Bootstrap
//import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.
import {
  Alert,
  //Button,
  //Carousel,
  //Collapse,
  //Dropdown,
  Modal,
  //OffCanvas,
  //Popover,
  //ScrollSpy,
  Tab,
  //Toast,
  //Tooltip,
} from "bootstrap";

//import LazyLoad from "vanilla-lazyload";
//import { OverlayScrollbars } from "overlayscrollbars"; // Used on product filters

import validate from "jquery-validation";

import AOS from "aos"; //? https://github.com/michalsnik/aos
import Splide from "@splidejs/splide"; //? https://splidejs.com/
import GLightbox from "glightbox/dist/js/glightbox.js"; //? https://github.com/biati-digital/glightbox

import shave from "shave";

// | Template Components ----------------------------------------------------

// Cookies
//import "./components/cookieConsent/cookieOptions";
import "./components/cookiePopup";

// Navigation
import "./components/mainNavigation";
//import "./components/dropdownOnHover";

// Header
import "./components/fixedHeader";

// Images
//import "./components/imageLazyLoad";
import "./components/modernizr-webp";

// Videos
import "./components/LazyYouTubeVideos";

// Forms
import "./components/requestQuoteForm";
//import "./components/quantityInputs";

// Shop Specific
//import "./components/productFilters";
//import "./components/productGallery";
//import "./components/productGrid";
//import "./components/tableRowLinks";

// | Page Specific ----------------------------------------------------------

import "./contact";

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------

window.addEventListener("load", (event) => {
  AOS.init();

  // Light box
  var lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
  });

  shave(".ellipsis", 84, { character: "..." });
});

document.addEventListener("DOMContentLoaded", function () {
  function parallaxBlur() {
    var parallaxElement = document.querySelector(".parallax-bg");

    if (parallaxElement) {
      var elementHeight = parallaxElement.offsetHeight;

      var scrollPos = window.pageYOffset;
      var transformValue = scrollPos / 40;
      var opacityValue = 1 - scrollPos / 1000;
      var blurValue = Math.min(scrollPos / 100, 3);

      if (scrollPos < elementHeight) {
        Object.assign(parallaxElement.style, {
          transform: "translate3d(0," + transformValue + "%, 0)",
          opacity: "" + opacityValue + "",
          filter: "brightness(.6) blur(" + blurValue + "px)",
        });
      }
    }
  }

  window.addEventListener("scroll", parallaxBlur, false);

  var carouselStandards = document.querySelector(".carousel-standards");

  if (carouselStandards) {
    var carouselStandard = new Splide(".carousel-standards", {
      type: "loop",
      gap: 80,
      padding: "80px",
      perPage: 3,
      perMove: 1,
      pagination: false,
      arrows: false,
      breakpoints: {
        576: {
          perPage: 1,
          arrows: true,
        },
        768: {
          perPage: 2,
          arrows: true,
        },
        992: {
          perPage: 3,
        },
      },
    }).mount();
  }
});

// | ------------------------------------------------------------------------
// | Debugging
// | ------------------------------------------------------------------------

// import "./debugging/cls";
